<template>
  <div class="action-button flex gap-4">
    <md-button
      v-if="$can(Student.actions.view, Student.subject)"
      class="md-just-icon md-warning md-simple table-action"
      @click.native="triggerDetail"
    >
      <md-icon>visibility</md-icon>
    </md-button>
    <md-button
      v-if="$can(Behavior.actions.delete, Behavior.subject)"
      class="md-just-icon md-danger md-simple table-action "
      @click.native="triggerConfirmDelete"
    >
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>
<script>
import { getId } from "@/helpers/utils";
import { Behavior, Student } from "@/constants/Permissions";

export default {
  props: ["item"],
  inject: ["viewBehavior", "deleteBehavior"],
  data() {
    return {
      Behavior,
      Student
    };
  },
  methods: {
    triggerDetail() {
      this.viewBehavior(this.item);
    },
    triggerConfirmDelete() {
      this.deleteBehavior(getId(this.item));
    }
  }
};
</script>
